<template>
    <div>
        <Loader ref="Loader"></Loader>
        <ErrorModal ref="ErrorModal"></ErrorModal>
        <SuccessModal ref="SuccessModal"></SuccessModal>
        <YesNoModal ref="YesNoModal"></YesNoModal>
        <v-layout fill-height row mr-1 ml-1 mt-2>
            <v-flex xs12 sm12 md12 lg12 xl12>
                <v-card>
                    <v-card-text xs12 mt-3>
                        <v-layout v-for="venue in VenueList" :key="venue.Venue.ID" row wrap>
                            <v-toolbar color="primary" dark dense>
                                <v-spacer></v-spacer>
                                <v-toolbar-title>{{ venue.Venue.Name }}</v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                            <v-flex xs12>
                                <v-layout row wrap ma-4>
                                    <v-flex xs12 sm12 md12 lg12 xl12>
                                        <v-card class="mb-5" color="grey lighten-5" elevation="4">
                                            <v-card-title>Create Inspection Profile</v-card-title>
                                            <v-card-text>
                                                <v-layout justify-start row>
                                                    <v-flex xs2 mr-2 ml-2>
                                                        <v-checkbox v-model="venue.IsDefaultTemplate"
                                                            label="Default Template">
                                                        </v-checkbox>
                                                    </v-flex>
                                                    <v-flex mr-2 v-if="venue.IsDefaultTemplate == true">
                                                        <v-layout row wrap>
                                                            <v-flex xs10 sm10 md10 lg10 xl10>
                                                                <v-select v-model="venue.InspectionTemplate"
                                                                    label="Inspection" :items="InspectionTemplateTypes"
                                                                    item-text="Name" item-value="ID">
                                                                </v-select>
                                                            </v-flex>
                                                            <v-flex xs2 sm2 md2 lg2 xl2>
                                                                <v-btn fab small color="success"
                                                                    @click="CheckSelectedInspectionTemplate(venue)"
                                                                    :disabled="venue.InspectionTemplate == null">
                                                                    <v-icon>add</v-icon>
                                                                </v-btn>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex mr-2 v-if="!venue.IsDefaultTemplate">
                                                        <v-layout row wrap>
                                                            <v-flex xs10 sm10 md10 lg10 xl10>
                                                                <v-text-field label="New template name"
                                                                    v-model="venue.CustomerInspectionName">
                                                                </v-text-field>
                                                            </v-flex>
                                                            <v-flex xs2 sm2 md2 lg2 xl2>
                                                                <v-btn fab small color="success"
                                                                    @click="AddCustomerInspectionTemplate(venue)"
                                                                    :disabled="venue.CustomerInspectionName == null">
                                                                    <v-icon>add</v-icon>
                                                                </v-btn>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>
                                                </v-layout>
                                            </v-card-text>
                                        </v-card>
                                    </v-flex>
                                </v-layout>

                                <!-- INSPECTION CARDS-->
                                <v-layout row wrap v-for="(item, idx) in venue.Inspections" :key="idx">
                                    <v-flex pa-2 xs12 md4 v-for="(subItem, index) in item" :key="index">
                                        <v-card>
                                            <v-toolbar color="secondary" dark dense>
                                                <v-toolbar-title>{{subItem.CustomerInspection.Name}}</v-toolbar-title>
                                                <v-spacer></v-spacer>
                                                <v-btn icon dark @click="deleteInspection(subItem, item, venue)">
                                                    <v-icon>delete</v-icon>
                                                </v-btn>
                                            </v-toolbar>
                                            <v-card-text>
                                                <v-list v-for="newItem in subItem.CustomerInspectionItems"
                                                    :key="newItem.Name">
                                                    <v-list-tile>
                                                        <v-list-tile-content>
                                                            <v-list-tile-title>{{ newItem.Name }}</v-list-tile-title>
                                                        </v-list-tile-content>
                                                        <v-list-tile-action>
                                                            <v-btn icon ripple
                                                                @click="deleteInspectionItem(newItem, subItem)">
                                                                <v-icon color="grey lighten-1">delete</v-icon>
                                                            </v-btn>
                                                        </v-list-tile-action>
                                                    </v-list-tile>
                                                </v-list>
                                            </v-card-text>
                                            <v-layout justify-end>
                                                <v-btn medium flat fab
                                                    v-if="HasAccess('CUSTOMER_MANAGEMENT', 'CREATE')">
                                                    <v-icon color="success"
                                                        @click="ShowInspectionItemDialog(item[0], subItem)">
                                                        add_circle
                                                    </v-icon>
                                                </v-btn>
                                            </v-layout>
                                        </v-card>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="AddInspectionItemDialog" width="650px" offset-x persistent>
            <v-form>
                <v-card>
                    <v-toolbar color="secondary" dark dense>
                        <v-toolbar-title>Add Inspection Item</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon dark @click="AddInspectionItemDialog = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-layout row ma-4>
                        <v-flex xs12>
                            <v-text-field v-model="InspectionName" label="Inspection" disabled></v-text-field>
                            <v-text-field v-model="InspectionItemName" label="New item name"></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-card-actions>
                        <v-layout justify-end>
                            <v-btn color="primary" @click="AddInspectionItem()" :disabled="InspectionItemName == null">
                                Create</v-btn>
                            <v-btn flat @click="AddInspectionItemDialog = false">Cancel
                            </v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            let self = this;
            return {
                VenueList: [],
                AddInspectionItemDialog: false,
                InspectionTemplates: [],
                InspectionTemplateTypes: [],
                InspectionTemplateSelected: 0,
                CustomerInspectionItems: {
                    Name: null
                },
                InspectionName: null,
                InspectionItemName: null,
                Templates: [],
                customerInspectionID: 0,
                venueID: 0,
                tempItem: []
            }
        },
        props: ["CustomerID"],
        mounted() {
            let self = this;

            self.FetchVenues();
            self.FetchInspectionTemplates();
        },
        methods: {
            FetchVenues() {
                let self = this;
                console.log("CUSTOMER ID - INSPECTION", self.CustomerID)
                self.get(`CustomerVenue/CustomerID?customerID=${self.CustomerID}`)
                    .then(r => {
                        r.data.forEach(venue => {
                            self.VenueList.push({
                                Venue: venue,
                                Inspections: []
                            })
                        });
                        console.log("[VENUE DATA]", self.VenueList);
                    })
                    .catch(error => {
                        console.log("VENUE:", error);
                    });
            },
            FetchInspectionTemplates() {
                let self = this;

                self.get('InspectionTemplate/Complex').then(r => {
                    self.InspectionTemplates = r.data;
                    console.log("INSPECTION TEMPLATES", self.InspectionTemplates) // templates with their items

                    self.InspectionTemplates.forEach(el => {
                        self.InspectionTemplateTypes.push(el.InspectionTemplate);
                    })
                })
            },
            CheckSelectedInspectionTemplate(venue) {
                let self = this;

                // GET THE INSPECTION TEMLPATE AND POST IT TO THE CUSTOMER INSPECTION
                self.get(`InspectionTemplate/ID?inspectionTemplateID=${venue.InspectionTemplate}`).then(r => {
                    console.log("Selected", r.data)
                    var inspectionItemsToPost = [];
                    r.data[0].InspectionTemplateItems.forEach(el => {
                        inspectionItemsToPost.push({
                            Name: el.Name
                        });
                    })
                    // POST TO CUSTOMER INSPECTION
                    let Request = [{
                        CustomerInspection: {
                            CustomerID: self.CustomerID,
                            CustomerVenueID: venue.Venue.ID,
                            Name: r.data[0].InspectionTemplate.Name
                        },
                        CustomerInspectionItems: inspectionItemsToPost
                    }]
                    console.log("REQUEST", Request)
                    self.post('CustomerInspections/PostAll', Request).then(result => {
                        console.log("SUCCESS", result.data)
                        venue.InspectionTemplate = null;

                        self.GetCustomerInspections(venue);
                    })
                })
            },
            GetCustomerInspections(venue) {
                let self = this;

                console.log("VENUE", venue)
                venue.Inspections = [];
                self.$nextTick(() => {
                    self.get(
                        `CustomerInspections/GetAll?customerID=${self.CustomerID}&venueID=${venue.Venue.ID}`
                    ).then(r => {
                        console.log("CUSTOMER INSPECTIONS", r.data);
                        self.Templates = r.data;
                        venue.Inspections.push(r.data)

                        console.log("??", venue)
                        self.tempItem = venue;
                    })
                })
            },
            AddCustomerInspectionTemplate(venue) {
                let self = this;

                let Request = {
                    CustomerID: self.CustomerID,
                    CustomerVenueID: venue.Venue.ID,
                    Name: venue.CustomerInspectionName
                }
                console.log("INSPECTION REQUEST TO POST", Request)

                self.post('CustomerInspections/PostInspection', Request).then(r => {
                    console.log("Success", r.data)
                    self.GetCustomerInspections(venue);
                    venue.CustomerInspectionName = null;
                })
            },
            ShowInspectionItemDialog(item, subItem) {
                let self = this;
                console.log("dialog", item, subItem)
                self.InspectionName = item.CustomerInspection.Name;
                self.venueID = item.CustomerInspection.CustomerVenueID;
                self.customerInspectionID = item.CustomerInspection.ID;
                self.AddInspectionItemDialog = true;
            },
            // AddInspectionItem(subItem, venue) {
            //     let self = this;
            //     console.log(":", subItem)
            //     let Request = {
            //         CustomerInspectionID: self.customerInspectionID,
            //         Name: self.InspectionItemName
            //     }
            //     console.log("ITEM TO ADD", Request)

            //     self.post('CustomerInspections/PostInspectionItem', Request).then(res => {
            //         console.log("fuck yes", res.data)
            //         //subItem.CustomerInspectionItems.push(res.data);
            //         self.GetCustomerInspections(venue);
            //         self.AddInspectionItemDialog = false;
            //         self.InspectionName = null;
            //         self.InspectionItemName = null;
            //     })
            // },
            AddInspectionItem() {
                let self = this;

                let Request = {
                    CustomerInspectionID: self.customerInspectionID,
                    Name: self.InspectionItemName
                }
                console.log("ITEM TO ADD", Request)
                console.log("temp item", self.tempItem)

                self.post('CustomerInspections/PostInspectionItem', Request).then(res => {
                    self.$nextTick(() => {
                        //self.GetInspectionByInspectionID(self.tempItem, self.customerInspectionID);
                        self.GetCustomerInspections(self.tempItem)
                        //self.GetCustomerInspections(venue)
                        self.AddInspectionItemDialog = false;
                        self.InspectionName = null;
                        self.InspectionItemName = null;
                    })

                })
            },
            deleteInspectionItem(item, subItem) {
                let self = this;

                console.log(item);
                console.log(":", subItem)

                self.$refs.YesNoModal.show(
                    "Are you sure you want to delete this inspection item?",
                    function (yes) {
                        if (yes == true) {
                            self.$refs.Loader.show(true);
                            self.$refs.Loader.setText("Deleting item...");
                            self.delete(`CustomerInspectionItem/Delete?id=${item.ID}`)
                                .then(result => {
                                    self.$refs.Loader.hide();
                                    if (result.data == true) {
                                        var index = subItem.CustomerInspectionItems.indexOf(item);
                                        if (index > -1) {
                                            subItem.CustomerInspectionItems.splice(index, 1);
                                        }
                                    }
                                })
                                .catch(error => {
                                    self.$refs.Loader.hide();
                                    self.$refs.ErrorModal.show();
                                    self.$refs.ErrorModal.setText(error.toString());
                                });
                        }
                    })
            },
            deleteInspection(subItem, item, venue) {
                let self = this;
                console.log("DELETE", subItem)
                console.log("ITEM", item)

                self.$refs.YesNoModal.show(
                    "Are you sure you want to delete this inspection?",
                    function (yes) {
                        if (yes == true) {
                            self.$refs.Loader.show(true);
                            self.$refs.Loader.setText("Deleting item...");
                            self.delete(`CustomerInspection/Delete?id=${subItem.CustomerInspection.ID}`)
                                .then(result => {
                                    self.$refs.Loader.hide();
                                    if (result.data == true) {
                                        var index = item.indexOf(subItem);
                                        if (index > -1) {
                                            item.splice(index, 1);
                                        }
                                    }
                                })
                                .catch(error => {
                                    self.$refs.Loader.hide();
                                    self.$refs.ErrorModal.show();
                                    self.$refs.ErrorModal.setText(error.toString());
                                });
                        }
                    })

            }
        }
    }
</script>

<style>

</style>